import AssetsResource from './AssetsResource';

export default AssetsResource;
